(function() {
	Vue.component('nominow-input-basicselect', {
		model: {
			prop: 'value',
			event: 'change'
		},
		props: {
			value: {
				type: Object,
				required: true,
				default: () => ({})
			},
			label: {
				type: String,
				required: false
			},
			name: {
				type: String,
				required: true,
				default: 'Name'
			},
			required: {
				type: Boolean,
				required: false
			},
			css: {
				type: String,
				required: false
			},
			options: {
				type: Array,
				required: true,
				default: () => []
			},
			nomui: {
				type: Boolean,
				required: false
			}
		},
		template: `<div class="field" :class="{'mui-textfield' : (!nomui)}">
            <label v-if="label">{{label}}</label>                    
            <select :class="css" :name="name || label" v-model="value"  @change="$emit('change', $event.target.value)">
                <option value=""></option>
                <option v-for="el in options" :value="el.key">{{el.value}}</option>
            </select>           
        </div>
        `
	});
})();
